// Golf Hustler HELP page (Rules & how-to) — themed, links to the game rules.
import { Link } from 'react-router-dom'

export default function GHelp() {
  return (
    <div className="hh-page">
      <h1 className="hh-page-title">Help — Rules &amp; How-To</h1>
      <p className="hh-page-sub">Learn every Golf Hustler game, then build your setup and play it from the app.</p>
      <div className="hh-help-grid">
        <Link to="/admin/gg/games" className="hh-help-card">
          <span className="hh-help-card-title">Learn every game</span>
          <span className="hh-help-card-sub">Wolf, Vegas, Skins, Dots, Nassau, Scotch and more — the rules and how each one pays.</span>
        </Link>
        <Link to="/admin/gg-features" className="hh-help-card">
          <span className="hh-help-card-title">How it works</span>
          <span className="hh-help-card-sub">Pick a game → set your players &amp; stakes → Save → open it in the Golf Hustler app on the course.</span>
        </Link>
      </div>
    </div>
  )
}
